// import { Link } from "react-router-dom";
const BlockGcModal = ({message}) => {
  return (
    <div className="inner-page block-modal-page">
      <div className="page-title text-center">
        <div className="modal-txt">
          <h3>
            <span>
            {message !== "" && message !== undefined ? message : "General Counsel signup has temporary disabled, please connect with administrator for more detail."}
            </span>
          </h3>
        </div>
        <div className="modal-action">
          {/* <Link to="/login" className="cmn-btn btn-primary">
            Sign In
          </Link>
          <Link to="/" className="cmn-btn btn-secondary">
           Home
          </Link> */}
        </div>
      </div>
    </div>
  );
};

export default BlockGcModal;
